import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ListItem } from '../ListItem';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            height: '46px',
            color: theme.palette.text.secondary,
            '& svg': {
                color: theme.palette.text.secondary,
            },
            // Needed for high contrast mode
            borderLeft: "4px solid ".concat(theme.palette.highContrastOnly.main),
            '.bb-ui-navigation-list-horizontal &': {
                padding: '0',
                borderLeft: 'none',
                // Needed for high contrast mode
                borderBottom: "4px solid ".concat(theme.palette.highContrastOnly.main),
            },
            '&:hover, &:focus, &:active': {
                backgroundColor: 'unset',
                color: theme.palette.text.primary,
                borderColor: theme.palette.border.main,
                '& svg': {
                    color: theme.palette.text.primary,
                },
            },
        },
        active: {
            color: theme.palette.text.primary,
            borderColor: theme.palette.brand.main,
            '.bb-ui-navigation-list-horizontal &': {
                borderColor: theme.palette.brand.main,
            },
            '& svg': {
                color: theme.palette.text.primary,
            },
        },
    });
});
export var NavigationListItem = React.forwardRef(function (props, ref) {
    var _a;
    var classes = useStyles(props);
    var active = props.active, className = props.className, other = __rest(props, ["active", "className"]);
    return (React.createElement(ListItem, __assign({ ref: ref, component: "a", button: true, classes: { root: classes.root }, className: clsx(className, (_a = {},
            _a[classes.active] = active,
            _a)), "aria-current": active ? 'page' : undefined }, other)));
});
export default NavigationListItem;
//# sourceMappingURL=NavigationListItem.js.map